import {Pagination, ReportTableColumn, ReportTableConfigInterface, ReportTableData, } from 'appShared/components';

import {DialogButtonTypesEnum, DialogConfigInterface} from 'appShared/components/dialog';
import {
    MarketDataFeedsCostAlaricNonProSelector,
    MarketDataFeedsCostAlaricProSelector,
    MarketDataFeedsCostIndividualNonProSelector,
    MarketDataFeedsCostIndividualProSelector,
    MarketDataFeedsCurrencySelector,
    MarketDataFeedsDescriptionSelector,
    MarketDataFeedsExchangeSelector,
    MarketDataFeedsNameSelector,
    MarketDataFeedsPlatformSelector
} from 'appAssets/selectors';
import {ConstraintsCollection, MarketDataFeedBundleFilterModel, MarketDataFeedFilterModel, ReportFilterConstraintsEnum} from '@spa/api';

export const PanelMarketDataFeedsDataTableConfig = (hideExchange = false, hideAlaricCosts = false): ReportTableConfigInterface => {
    const columns = [
        new ReportTableColumn({
            label: 'Name',
            selector: MarketDataFeedsNameSelector,
        }),
    ];

    if (!hideAlaricCosts) {
        columns.push(
            new ReportTableColumn({
                label: 'Cost To Alaric (pro)',
                selector: MarketDataFeedsCostAlaricProSelector,
            })
        );
        columns.push(
            new ReportTableColumn({
                label: 'Cost To Alaric (non-pro)',
                selector: MarketDataFeedsCostAlaricNonProSelector,
            })
        );
    } else {
        columns.push(
            new ReportTableColumn({
                label: 'Platform',
                selector: MarketDataFeedsPlatformSelector,
            }),
        );
    }

    columns.push(
        new ReportTableColumn({
            label: hideAlaricCosts ? 'Price (pro)' : 'Individual Price (pro)',
            selector: MarketDataFeedsCostIndividualProSelector,
        }),
    );
    columns.push(
        new ReportTableColumn({
            label: hideAlaricCosts ? 'Price (non-pro)' : 'Individual Price (non-pro)',
            selector: MarketDataFeedsCostIndividualNonProSelector,
        }),
    );

    columns.push(
        new ReportTableColumn({
            label: 'Currency',
            selector: MarketDataFeedsCurrencySelector,
        }),
    );

    if (!hideExchange) {
        columns.push(new ReportTableColumn({
                label: 'Market',
                selector: MarketDataFeedsExchangeSelector,
            })
        );
    }

    columns.push(new ReportTableColumn({
            label: 'Description',
            selector: MarketDataFeedsDescriptionSelector,
        })
    );

    return {
        rows: [],
        columns,
        hiddenColumnIds: [],
        actionMenu: false
    };
};

export const MarketDataFeedsDataTableItems = (hideExchange = false, hideAlaricCosts = false): ReportTableData[] => {
    const items = [
        new ReportTableData<string>({
            colId: MarketDataFeedsNameSelector,
            value: null,
            hidden: false,
            class: 'custom-lg-table-col'
        }),
    ];

    if (!hideAlaricCosts) {
        items.push(
            new ReportTableData<string>({
                colId: MarketDataFeedsCostAlaricProSelector,
                value: null,
                hidden: false
            }),
        );
        items.push(
            new ReportTableData<string>({
                colId: MarketDataFeedsCostAlaricNonProSelector,
                value: null,
                hidden: false
            }),
        );
    } else {
        items.push(
            new ReportTableData<string>({
                colId: MarketDataFeedsPlatformSelector,
                value: null,
                hidden: false
            }),
        );
    }

    items.push(
        new ReportTableData<string>({
            colId: MarketDataFeedsCostIndividualProSelector,
            value: null,
            hidden: false
        }),
    );

    items.push(
        new ReportTableData<string>({
            colId: MarketDataFeedsCostIndividualNonProSelector,
            value: null,
            hidden: false
        }),
    );

    items.push(
        new ReportTableData<string>({
            colId: MarketDataFeedsCurrencySelector,
            value: null,
            hidden: false
        }),
    );

    if (!hideExchange) {
        items.push(new ReportTableData<string>({
                colId: MarketDataFeedsExchangeSelector,
                value: null,
                hidden: false
            })
        );
    }

    items.push(new ReportTableData<string>({
            colId: MarketDataFeedsDescriptionSelector,
            value: null,
            hidden: false,
            class: 'custom-lg-table-col'
        })
    );

    return items;
};

export const RemoveFeedsBundleDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm,
                hidden: true,
                customText: 'Remove'
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false,
        disabledCloseBtn: true
    };
};

export const getDeletableMarketDataFeedBundleFilterModel = (itemsPerPage: number) => {
    return new MarketDataFeedBundleFilterModel(
        new ConstraintsCollection(),
        Pagination.defaultPagesChunk - 1,
        MarketDataFeedBundleFilterModel.getCreatedTimeSelector(),
        Pagination.calculateItemsPerPagesChunk(itemsPerPage),
        false
    );
};

export const defaultMarketDataFeedBundleFilterModel = (showOneFeedBundle: boolean, itemsPerPage = Pagination.defaultItemsPerPage) => {
    const filter = getDeletableMarketDataFeedBundleFilterModel(itemsPerPage);

    filter.addConstraintItem(
        ReportFilterConstraintsEnum.Equal,
        'deleted',
        'false'
    );

    if (showOneFeedBundle) {
        return filter;
    }

    filter.addConstraintItem(
        ReportFilterConstraintsEnum.NotEqual,
        'feedList',
        '1'
    );

    return filter;
};

export const defaultMarketDataFeedFilterModel = (itemsPerPage = Pagination.defaultItemsPerPage) => {
    const filter = new MarketDataFeedFilterModel(
        new ConstraintsCollection(),
        Pagination.defaultPagesChunk - 1,
        MarketDataFeedFilterModel.getCreatedTimeSelector(),
        Pagination.calculateItemsPerPagesChunk(itemsPerPage),
        false
    );

    filter.addConstraintItem(
        ReportFilterConstraintsEnum.Equal,
        'deleted',
        'false'
    );

    return filter;
};
